import HorseDetails from './HorseDetails';

export default HorseDetails;
